// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as AcademyComponents$LiteracyplanetClientSxEntry from "./AcademyComponents.res.mjs";
import * as AcademyMenuQueries$LiteracyplanetClientSxEntry from "./AcademyMenuQueries.res.mjs";

function AcademyMenuContainer(props) {
  var onNavActivities = props.onNavActivities;
  var onNavSubCategory = props.onNavSubCategory;
  var res = AcademyMenuQueries$LiteracyplanetClientSxEntry.useMenu(props.id, "LEVEL_7");
  console.log(res);
  var tmp;
  if (typeof res !== "object") {
    tmp = null;
  } else {
    var res$1 = res._0;
    tmp = React.createElement(React.Fragment, {}, React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.Header.make, {
              children: null
            }, React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.Title.make, {
                  children: "Academy"
                }), React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.ActivityHeaderTabs.make, {
                  onNavSubCategory: onNavSubCategory,
                  strands: res$1.strands
                })), React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.MenuMainBody.make, {
              children: Belt_Array.map(res$1.categories, (function (categories) {
                      return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.MenuNavContainer.make, {
                                  children: Belt_Array.map(categories, (function (category) {
                                          return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.MenuNavButton.make, {
                                                      onClick: (function (param) {
                                                          if (category.hasActivities) {
                                                            return Curry._1(onNavActivities, category.id);
                                                          } else {
                                                            return Curry._1(onNavSubCategory, category.id);
                                                          }
                                                        }),
                                                      children: category.title
                                                    });
                                        }))
                                });
                    }))
            }));
  }
  return React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.Layout.make, {
              children: React.createElement(AcademyComponents$LiteracyplanetClientSxEntry.Content.make, {
                    children: tmp
                  })
            });
}

var make = AcademyMenuContainer;

export {
  make ,
}
/* react Not a pure module */
